export default __webpack_public_path__ + "static/media/icon_gearchecking.09c87bcf.png";